import Chart from 'react-apexcharts';
import { toFixedTrunc } from '../../../client/Juno/helpers';

const CryptoGraph = ({
    width = 165,
    name = 'crypto graph',
    data,
    view = 'compact',
    height,
    isMobile,
}) => {
    if (!data?.length) {
        return null;
    }

    const series = [
        {
            name,
            data,
        },
    ];

    const views = {
        compact: {
            chart: {
                id: `crypto-${name}-chart`,
                type: 'line',
                toolbar: {
                    show: false,
                },
                zoom: {
                    enabled: false,
                },
            },
            tooltip: {
                enabled: false,
            },
            stroke: {
                // curve: 'smooth',
                width: 1,
            },
            grid: {
                // padding: { left: 0, right: 0, top: 0, bottom: 0 },
                show: false,
                strokeDashArray: 0,
                xaxis: {
                    lines: {
                        show: false,
                    },
                },
                yaxis: {
                    lines: {
                        show: false,
                    },
                },
            },
            xaxis: {
                labels: {
                    show: false,
                },
                axisBorder: {
                    show: false,
                },
                axisTicks: {
                    show: false,
                },
                type: 'datetime',
            },
            yaxis: {
                labels: {
                    show: false,
                },
                axisBorder: {
                    show: false,
                },
                axisTicks: {
                    show: false,
                },
            },
            colors: ['#3CCB7F'],
        },
        expand: {
            chart: {
                id: `crypto-${name}-chart`,
                type: 'area',
                toolbar: {
                    show: false,
                },
                zoom: {
                    enabled: false,
                },
                stacked: false,
                background: 'var( --expand-graph-bg)',
            },
            tooltip: {
                enabled: true,
            },
            stroke: {
                show: true,
                curve: 'straight',
                width: 2,
                colors: ['var(--expand-graph-shade)'],
            },
            markers: {
                size: 0,
            },
            dataLabels: {
                enabled: false,
            },
            grid: {
                show: true,
                strokeDashArray: 0,
                borderColor: 'var(--expand-graph-border)',
                xaxis: {
                    lines: {
                        show: false,
                    },
                },
                yaxis: {
                    lines: {
                        show: true,
                    },
                },
            },
            xaxis: {
                labels: {
                    show: !isMobile,
                    style: {
                        fontSize: '12px',
                        cssClass: 'fill-[#70707B] dark:fill-[#A0A0AB]',
                    },
                    formatter: function (val) {
                        return new Date(val)
                            .toLocaleDateString('en-US', {
                                month: 'short',
                                day: 'numeric',
                            })
                            .replace(' ', ', ');
                    },
                },
                tickAmount: 4,
                axisBorder: {
                    show: false,
                },
                axisTicks: {
                    show: false,
                },
            },
            yaxis: {
                labels: {
                    show: true,
                    formatter: function (val) {
                        return `$ ${toFixedTrunc(val, 2)}`;
                    },
                    style: {
                        fontSize: '14px',
                        cssClass: 'fill-[#70707B] dark:fill-[#A0A0AB]',
                    },
                },
                axisBorder: {
                    show: false,
                },
                axisTicks: {
                    show: false,
                },
            },
            fill: {
                type: 'gradient',
                gradient: {
                    type: 'vertical',
                    shadeIntensity: 1,
                    gradientToColors: ['var(--expand-graph-shade)'],
                    inverseColors: false,
                    opacityFrom: 0.2,
                    opacityTo: 0.02,
                    colorStops: [],
                },
                colors: ['var(--expand-graph-shade)'],
            },
        },
    };

    let options = views[view];

    return (
        <Chart
            options={options}
            series={series}
            width={width}
            type={options?.chart?.type}
            {...(height ? { height } : {})}
        />
    );
};

export default CryptoGraph;
